gsap.registerPlugin(ScrollTrigger, ScrollSmoother);



if (document.body.classList.contains('multi-scroller')) {

  // create the smooth scroller FIRST!
  let smoother = ScrollSmoother.create({
    wrapper: '#multi-scroller',
    content: '#site-content-wrapper',
    smooth: 0.1,
    effects: true,
    smoothTouch: 0,
  });

  const anchorLinks = document.querySelectorAll('a[href^="#"]:not(.nav-menu a[href="#"])');

  // 3. Add click event listeners
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault(); // Stop default jump

      const targetId = link.getAttribute('href'); // Get the #id

      // Use ScrollSmoother's scrollTo to animate up or down smoothly
      // smoother.scrollTo(targetId, true, 'top top') - 160;

      var targetY = smoother.offset(targetId, "top top") - 150;
      smoother.scrollTo(targetY, true);

      history.pushState(null, null, targetId); // Update URL hash without jumping
    });
  });
}


// Fade in .screenshot when a release-card scrolls into view
$(window).on('scroll', function() {
  $('.release-card').each(function() {
    var $this = $(this);
    var cardId = $this.attr('id');
    var $background = $('.screenshot#background-' + cardId.split('-')[1]);
    // console.log('cardId: ' + cardId);
    // console.log('backgroundId: ' + $background.attr('id'));

    if ($this.length && $background.length) {
      var cardTop = $this.offset().top;
      var cardBottom = cardTop + $this.outerHeight();
      var windowTop = $(window).scrollTop();
      var windowBottom = windowTop + $(window).height() - 120; // Add some buffer to the bottom of the window

      if (cardBottom > windowTop && cardTop < windowBottom) {
        $background.fadeIn();
      } else {
        $background.fadeOut();
      }
    }
  });
});

$('.news-cards').on('mouseenter', function() {
  const newsTilt = $('.news-card').tilt({
    scale: 1.025,
    speed: 900,
    maxTilt: 8,
    perspective: 800,
    transformStyle: 'preserve-3d',
    glare: true,
    maxGlare: 0.1,
    glarePrerender: true
  });
});

// swiperjs
const accoladeSlider = new Swiper('.accolade-slides', {
  speed: 1000,
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 5000,
  }
});

$('.album-card-content').on('mouseenter', function() {
  $(this).closest('.cover-block').addClass('hover');
});
$('.album-card-content').on('mouseleave', function() {
  $(this).closest('.cover-block').removeClass('hover');
});

// rolling start!
$(function() {
  if ('ontouchstart' in window || 'ontouch' in window) {
    $('body').addClass('touch');
  }

  const releaseTilt = $('.tile').tilt({
    scale: 1.025,
    speed: 900,
    maxTilt: 8,
    perspective: 800,
    transformStyle: 'preserve-3d',
    glare: true,
    maxGlare: 0.1,
    glarePrerender: true
  });

  // const powerblockTilt = $('.power-block').tilt({
  //   scale: 1.025,
  //   speed: 900,
  //   maxTilt: 8,
  //   perspective: 800,
  //   transformStyle: 'preserve-3d',
  //   glare: true,
  //   maxGlare: 0.1,
  //   glarePrerender: true
  // });

  // data-tilt data-tilt-scale="1.025" data-tilt-speed="900" data-tilt-max="8" data-tilt-perspective="800" data-tilt-transform-style="preserve-3d" data-tilt-glare="true" data-tilt-maxglare="0.1" data-tilt-glare-prerender="true"
  // tilt.on('change', callback);


  $('.btn.multiple').on('click', function() {
    $('.multiple-links').toggleClass('active');
  });

  $('.multiple-links').on('click', function() {
    $(this).removeClass('active');
  });

  // hamburger action
  $('.hamburger').on('click', function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-active');
  });

  $('.gallery').each(function() { // the containers for all your galleries
    $(this).magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        /*titleSrc: function(item) {
          return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
        }*/
      }
    });
  });

  $('.modal-video').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  $('.play-trailer').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,

    callbacks: {
      open: function() {
        // Will fire when this exact popup is opened
        // this - is Magnific Popup object
        var vid = $('.hero').find('video');
        if (vid.length > 0) {
          $(vid)[0].pause();
        }
      },
      close: function() {
        // Will fire when popup is closed
        var vid = $('.hero').find('video');
        if (vid.length > 0) {
          $(vid)[0].play();
        }
      }
    }
  });

});